import { render, staticRenderFns } from "./course-equivalent-form.vue?vue&type=template&id=951dd2ee&scoped=true&"
import script from "./course-equivalent-form.vue?vue&type=script&lang=js&"
export * from "./course-equivalent-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951dd2ee",
  null
  
)

export default component.exports